import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/pages/HomePage';
import Auth from './components/Auth';
import AuthCallbackPage from './components/pages/AuthCallbackPage';
import ResultPage from './components/pages/ResultPage';
import CollectionPage from './components/pages/CollectionPage';
import ShareImagePage from './components/pages/ShareImagePage';
import { Analytics } from "@vercel/analytics/react";
import { supabase } from './lib/supabase';

// Helper function to bind Amplitude user
const bindAmplitudeUser = (user) => {
  if (user && window.amplitude) {
    try {
      window.amplitude.setUserId(user.id);
      // Use identify API for user properties (new Amplitude SDK)
      const identifyObj = new window.amplitude.Identify();
      identifyObj.set('email', user.email);
      window.amplitude.identify(identifyObj);
      console.log('[App] Amplitude user bound:', user.id);
    } catch (e) {
      console.warn('[App] Amplitude binding failed:', e);
    }
  }
};

function App() {
  // Bind Amplitude user on app startup if already logged in
  useEffect(() => {
    const initAmplitudeUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        bindAmplitudeUser(session.user);
      }
    };

    initAmplitudeUser();

    // Also listen for auth state changes globally
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_IN' && session?.user) {
        bindAmplitudeUser(session.user);
      } else if (event === 'SIGNED_OUT') {
        // Clear Amplitude user on logout
        if (window.amplitude) {
          window.amplitude.setUserId(null);
          console.log('[App] Amplitude user cleared');
        }
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/result" element={<ResultPage />} />
        <Route path="/result/:requestId" element={<ResultPage />} />
        <Route path="/result/:requestId/:imageId" element={<ResultPage />} />
        <Route path="/share/image/:imageId" element={<ShareImagePage />} />
        <Route path="/collection/:collectionId" element={<CollectionPage />} />
        <Route path="/share/collection/:collectionId" element={<CollectionPage />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  );
}

export default App;